import axios from "axios";
import Modal from "react-modal";
import moment from "moment";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useReactToPrint } from "react-to-print";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import pImage from "../../../images/singleinvoice/print.svg";
import editImage from "../../../images/singleinvoice/edit.svg";
import { logout, reset } from "../../../features/auth/authSlice";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
// import editImage from "../../../images/icons/edit-pen.svg";
import deleteImage from "../../../images/icons/delete.svg";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { useActiveUser, useDeleteTimeOffRequest, useFetchLeaveTypes, useUpdateTimeOffRequest } from "../../../components/TimeOff/timeOffApi.jsx";
import { setNotification } from "../../../features/notification/notificationSlice.js";
// import CommnetContainer from "../../Comments/CommnetContatiner";
const CommnetContainer = lazy(() => import("../../../components/Comments/CommnetContatiner"));

const USER = 3;
const SUPER_ADMIN = 1;
const ADMIN = 2;
const TEAM_MANAGER = 7;

// const timeList = [
//   {
//     time_value: 9,
//     time: "09:00AM",
//   },
//   {
//     time_value: 9.5,
//     time: "09:30AM",
//   },
//   {
//     time_value: 10,
//     time: "10:00AM",
//   },
//   {
//     time_value: 10.5,
//     time: "10:30AM",
//   },
//   {
//     time_value: 11,
//     time: "11:00AM",
//   },
//   {
//     time_value: 11.5,
//     time: "11:30AM",
//   },
//   {
//     time_value: 12,
//     time: "12:00PM",
//   },
//   // {
//   //   time_value: 12.5,
//   //   time: "12:30PM",
//   // },
//   {
//     time_value: 13,
//     time: "01:00PM",
//   },
//   {
//     time_value: 13.5,
//     time: "01:30PM",
//   },
//   {
//     time_value: 14,
//     time: "02:00PM",
//   },
//   {
//     time_value: 14.5,
//     time: "02:30PM",
//   },
//   {
//     time_value: 15,
//     time: "03:00PM",
//   },
//   {
//     time_value: 15.5,
//     time: "03:30PM",
//   },
//   {
//     time_value: 16,
//     time: "04:00PM",
//   },
//   {
//     time_value: 16.5,
//     time: "04:30PM",
//   },
//   {
//     time_value: 17,
//     time: "05:00PM",
//   },
//   {
//     time_value: 17.5,
//     time: "05:30PM",
//   },
//   {
//     time_value: 18,
//     time: "06:00PM",
//   },
//   {
//     time_value: 18.5,
//     time: "06:30PM",
//   },
// ];

const ranges = [
  {
    label: "today",
    value: [new Date(), new Date()],
  },
  {
    label: "yesterday",
    value: [subDays(new Date(), 1), subDays(new Date(), 1)],
  },
];

const TimeOffActions = ({ timeOffData, refetch, componentRef, isRefetching }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEditId, setSelectedEditId] = useState("");
  const [userIdEdit, setUserIdEdit] = useState("");
  const [typeOfLeaveEdit, setTypeOfLeaveEdit] = useState("");
  const [dateRangeEdit, setDateRangeEdit] = useState(null);
  const [startTimeEdit, setStartTimeEdit] = useState("");
  const [endTimeEdit, setEndTimeEdit] = useState("");
  const [dateRangeTypeEdit, setDateRangeTypeEdit] = useState("single");
  const [uploadDocumentEdit, setUploadDocumentEdit] = useState(null);
  const [uploadDocumentEditName, setUploadDocumentEditName] = useState(null);
  const [noteEdit, setNoteEdit] = useState("");
  const [userEditIsValid, setUserEditIsValid] = useState(false);
  const [leaveTypeEditIsValid, setLeaveTypeEditIsValid] = useState(false);
  const [dateRangeEditIsValid, setDateRangeEditIsValid] = useState(false);
  const [startTimeEditIsValid, setStartTimeEditIsValid] = useState(false);
  const [endTimeEditIsValid, setEndTimeEditIsValid] = useState(false);
  const [documentEditIsValid, setDocumentEditIsValid] = useState(false);
  const [noteEditIsValid, setNoteEditIsValid] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [leaveTypeDropdownOpen, setLeaveTypeDropdownOpen] = useState(false);
  // const [startTimeDropdownOpen, setStartTimeDropdownOpen] = useState(false);
  // const [endTimeDropdownOpen, setEndTimeDropdownOpen] = useState(false);

  const userRef = useRef(null);
  const leaveTypeEditRef = useRef(null);
  const dateRangeRef = useRef(null);
  const dateRangeEditRef = useRef(null);
  const startTimeRef = useRef(null);
  const endTimeRef = useRef(null);
  const noteRef = useRef(null);
  const documentRef = useRef(null);
  const userSelectDropdownRef = useRef(null);
  const leaveTypeSelectDropdownRef = useRef(null);
  // const startTimeDropdownRef = useRef(null);
  // const endTimeDropdownRef = useRef(null);
  const user = useSelector((state) => state.auth.user)
  const { appSettings } = useSelector((state) => state.appSettings);
  let token = null;
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const { data: activeUser = [] } = useActiveUser(token);
  const { data: leaveTypesResp = [] } = useFetchLeaveTypes(token);
  const leaveType = Array.isArray(leaveTypesResp?.data) ? leaveTypesResp.data : [];
  const updateTimeOffRequestMutation = useUpdateTimeOffRequest(token);
  const deleteTimeOffRequestMutation = useDeleteTimeOffRequest(token);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "invoice-data",
  });

  // const createPdf = async (e) => {
  //   e.preventDefault();
  //   setIsCreatingPdf(true); // Set loading state to true

  //   try {
  //     await axios.post(`/api/invoice/create`, props.timeOffData, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     const response = await axios.get(`/api/invoice/download/created/pdf`, {
  //       responseType: "blob",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     const filename = `${props.timeOffData.inv_number}.pdf`;
  //     const pdfBlob = new Blob([response.data], { type: "application/pdf" });
  //     saveAs(pdfBlob, filename);
  //     toast.success(`Invoice "${props.timeOffData.inv_number}" downloaded successfully!`, {
  //       position: "bottom-right",
  //       autoClose: 1500,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light",
  //     });
  //     global.config.activityLog(
  //       window.location.href,
  //       "Invoice",
  //       `Invoice "${props.timeOffData.inv_number}" Downloaded Successfully!`
  //     );
  //   } catch (error) {
  //     console.error(error);
  //     global.config.slackMessage(error.toString());
  //     if (error.response?.data?.status === "deleted") {
  //       localStorage.removeItem("user");
  //       dispatch(logout());
  //       dispatch(reset());
  //       dispatch(invoiceReset());
  //       dispatch(headerReset());
  //       dispatch(appSettingsReset());
  //       toast.error('This user is deleted!', {
  //         position: "bottom-right",
  //         autoClose: 1500,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //       });
  //       navigate("/");
  //       return;
  //     }
  //     // Display an error message to the user
  //     alert("Something went wrong while creating the PDF.");
  //   } finally {
  //     setIsCreatingPdf(false); // Set loading state to false, regardless of success or failure
  //   }
  // };

  // if (timeOffData) {
  //   const encryptedId = AES.encrypt(props.timeOffData._id, 'encryptionKey').toString();
  //   encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
  // }

  const convertDecimalToTime = (decimalTime) => {
    const hours = Math.floor(decimalTime);
    const minutes = Math.round((decimalTime - hours) * 60);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };

  const handleEdit = () => {
    setIsEditModalOpen(true);
    setSelectedEditId(timeOffData._id);
    if (timeOffData.user) {
      setUserIdEdit(timeOffData.user._id);
    }
    if (timeOffData.type_of_leave) {
      setTypeOfLeaveEdit(timeOffData.type_of_leave._id);
    }
    setDateRangeEdit([new Date(timeOffData.start_date), new Date(timeOffData.end_date)]);
    if (
      moment(timeOffData.start_date)
        .tz(global.config.getTimeZone())
        .format("X") ===
      moment(timeOffData.end_date)
        .tz(global.config.getTimeZone())
        .format("X")
    ) {
      setStartTimeEdit(convertDecimalToTime(timeOffData.start_time));
      setEndTimeEdit(convertDecimalToTime(timeOffData.end_time));
      setDateRangeTypeEdit("single");
    } else {
      setStartTimeEdit("");
      setEndTimeEdit("");
      setDateRangeTypeEdit("multiple");
    }
    setUploadDocumentEditName(timeOffData.timeoff_document || null);
    setNoteEdit(timeOffData.note);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEditId("");
    setUserIdEdit("");
    setTypeOfLeaveEdit("");
    setDateRangeEdit(null);
    setStartTimeEdit("");
    setEndTimeEdit("");
    setDateRangeTypeEdit("single");
    setUploadDocumentEditName("");
    setNoteEdit("");
    setUserEditIsValid(false);
    setLeaveTypeEditIsValid(false);
    setDateRangeEditIsValid(false);
    setStartTimeEditIsValid(false);
    setEndTimeEditIsValid(false);
    setDocumentEditIsValid(false);
    setNoteEditIsValid(false);
  };

  const handleSelectEdit = (ranges) => {
    setDateRangeEdit(ranges);

    if (ranges !== null) {
      if (moment(ranges[0]).tz(global.config.getTimeZone()).format("X") === moment(ranges[1]).tz(global.config.getTimeZone()).format("X")) {
        setDateRangeTypeEdit('single');
      } else {
        setDateRangeTypeEdit('multiple');
      }
    }
  };

  const handleToggleUserDropdown = () => {
    try {
      setUserSearchTerm('');
      setUserDropdownOpen((prevOpen) => !prevOpen);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectUserEdit = (userId) => {
    try {
      setUserIdEdit(userId);
      setUserDropdownOpen(false);
      setUserEditIsValid(false);
      setUserSearchTerm('');
    } catch (error) {
      console.log(error);
    }
  };

  const handleUserSearchInputChange = (e) => {
    setUserSearchTerm(e.target.value);
  };

  // const handleToggleStartTimeDropdown = () => {
  //   setStartTimeDropdownOpen(!startTimeDropdownOpen);
  // };

  // const handleToggleEndTimeDropdown = () => {
  //   setEndTimeDropdownOpen(!endTimeDropdownOpen);
  // };

  const filteredUsers = activeUser.filter((user) => {
    const fullName = user.first_name
      ? `${user.first_name} ${user.middle_name || ''} ${user.last_name}`
      : `${user.company_first_name ? user.company_first_name + (user.company_last_name && user.company_last_name) : user.company_name}`;
    return fullName?.toLowerCase().includes(userSearchTerm?.toLowerCase());
  });

  const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv"];

  const handleUploadDocEditChange = (event) => {
    const selectedFile = event.target.files[0];
    setDocumentEditIsValid(false);
    setUploadDocumentEditName("");
    if (selectedFile) {
      const fileExtension = selectedFile.name.split(".").pop()?.toLowerCase();
      if (allowedExtensions.includes(fileExtension)) {
        setUploadDocumentEdit(selectedFile);
      } else {
        setDocumentEditIsValid(true);
        documentRef && documentRef.current.focus();
        toast.error("Invalid file format. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.!!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // Optionally, you can clear the input
        event.target.value = null;
      }
    }
  };

  const convertTimeToDecimal = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours + minutes / 60;
  };

  const handleTimeOffEditSubmit = async (event) => {
    event.preventDefault();
    setUserEditIsValid(false);
    setLeaveTypeEditIsValid(false);
    setDateRangeEditIsValid(false);
    setStartTimeEditIsValid(false);
    setEndTimeEditIsValid(false);
    setDocumentEditIsValid(false);
    setNoteEditIsValid(false);
    const startDecimal = convertTimeToDecimal(startTimeEdit);
    const endDecimal = convertTimeToDecimal(endTimeEdit);
    if (
      typeOfLeaveEdit === "" ||
      userIdEdit === "" ||
      dateRangeEdit === null ||
      noteEdit === ""
    ) {
      if (userIdEdit === "") {
        setUserEditIsValid(true);
        userRef.current?.focus();
        return;
      } else if (typeOfLeaveEdit === "") {
        setLeaveTypeEditIsValid(true);
        leaveTypeEditRef.current?.focus();
        return;
      } else if (dateRangeEdit === null) {
        setDateRangeEditIsValid(true);
        dateRangeEditRef.current?.scrollIntoView({ behavior: "smooth" });
        return;
      } else if (
        moment(dateRangeEdit[0])
          .tz(global.config.getTimeZone())
          .format("X") ===
        moment(dateRangeEdit[1])
          .tz(global.config.getTimeZone())
          .format("X")
      ) {
        if (startTimeEdit === "") {
          setStartTimeEditIsValid(true);
          startTimeRef.current?.focus();
          return;
        } else if (endTimeEdit === "") {
          setEndTimeEditIsValid(true);
          endTimeRef.current?.focus();
          return;
        }
      } else if (noteEdit === "") {
        setNoteEditIsValid(true);
        noteRef.current?.focus();
        return;
      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (
      moment(dateRangeEdit[0])
        .tz(global.config.getTimeZone())
        .format("X") ===
      moment(dateRangeEdit[1])
        .tz(global.config.getTimeZone())
        .format("X")
    ) {
      if (startTimeEdit === endTimeEdit) {
        toast.error("Start time and End time shouldn't be same!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        endTimeRef.current?.focus();
        return;
      } else if (
        startTimeEdit &&
        endTimeEdit &&
        startDecimal >= endDecimal
      ) {
        toast.error("Start time should be less than End time!!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setStartTimeEditIsValid(true);
        setEndTimeEditIsValid(true);
        endTimeRef.current?.focus();
        return;
      } else if (startTimeEdit === "") {
        setStartTimeEditIsValid(true);
        startTimeRef.current?.focus();
        return;
      } else if (endTimeEdit === "") {
        setEndTimeEditIsValid(true);
        endTimeRef.current?.focus();
        return;
      }
    }

    const requestData = {
      type_of_leave: typeOfLeaveEdit,
      user: userIdEdit,
      start_date: dateRangeEdit[0],
      end_date: dateRangeEdit[1],
      // start_time: startTimeEdit,
      // end_time: endTimeEdit,
      start_time: convertTimeToDecimal(startTimeEdit),
      end_time: convertTimeToDecimal(endTimeEdit),
      note: noteEdit,
      timeZone: global.config.getTimeZone(),
    };

    const formData = new FormData();
    formData.append("timeoff_document", uploadDocumentEdit);

    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }

    try {
      setIsSubmitLoading(true);
      await updateTimeOffRequestMutation.mutateAsync({
        selectedId: selectedEditId,
        formData,
      });
      global.config.activityLog(
        window.location.href,
        "Time Off",
        `Time Off request (${selectedEditId}) updated successfully`
      );
      toast.success("Time-Off request updated successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch(setNotification(Date.now()));
      refetch();
      handleCloseEditModal();
    } catch (error) {
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "mailfailed") {
        toast.error(
          "Time Off Request updated successfully but something went wrong in sending mail!!",
          {
            position: "bottom-right",
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Time Off request (${selectedEditId}) updated successfully but something went wrong in sending mail!!`
        );
        refetch();
        handleCloseEditModal();
      } else if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      } else {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } finally {
      setIsSubmitLoading(false);
      handleCloseEditModal();
    }
  };

  const downloadTimeOffDoc = async (timeoff) => {
    try {
      const response = await axios.get(`/api/time-off/download/${timeoff}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, `${timeoff}`);
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Failed to download document", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsSubmitLoading(true);
      await deleteTimeOffRequestMutation.mutateAsync(timeOffData._id);

      toast.success("TimeOff request removed successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(
        window.location.href,
        "Time Off",
        `Time Off request (${timeOffData._id}) deleted successfully`
      );
      dispatch(setNotification(Date.now()));
      navigate("/user/time-off/overview");
    } catch (error) {
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(
        window.location.href,
        "Time Off",
        `Something went wrong while deleting Time Off request (${timeOffData._id})`
      );
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };

  const handleClickOutsideDropdown = (event) => {
    try {
      const isClickInsideUserSelectDropdown = userSelectDropdownRef.current && userSelectDropdownRef.current.contains(event.target);
      const isClickInsideLeaveTypeSelectDropdown = leaveTypeSelectDropdownRef.current && leaveTypeSelectDropdownRef.current.contains(event.target);

      if (!isClickInsideUserSelectDropdown) setUserDropdownOpen(false);
      if (!isClickInsideLeaveTypeSelectDropdown) setLeaveTypeDropdownOpen(false);

    } catch (error) {
      console.error("Error in handleClickOutsideDropdown:", error);
    }
  };

  useEffect(() => {
    try {
      document.addEventListener('click', handleClickOutsideDropdown);
    } catch (error) {
      console.error("Error attaching click listener:", error);
    }

    return () => {
      try {
        document.removeEventListener('click', handleClickOutsideDropdown);
      } catch (error) {
        console.error("Error removing click listener:", error);
      }
    };
  }, []);

  return (
    <div className="s1-contain s1-contain-with-comment">
      <div className="s1-contain-inner">
        <div className="bill-num-si">
          {isRefetching ? (
            <>
              <a className="invoice-num-01" style={{ display: "block", textDecoration: "none", pointerEvents: "none" }}>
                <div
                  style={{
                    width: "255px",
                    height: "31.72px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              </a>
              <div
                style={{
                  width: "84px",
                  height: "31px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "100px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </>
          ) : (
            <>
              <a className="invoice-num-01">
                {timeOffData?.time_off_request_id}
              </a>
              {timeOffData?.status && (
                <div className={`hide-mobile ${timeOffData.status === "Pending"
                  ? "pending"
                  : timeOffData.status === "Approved"
                    ? "approve-top"
                    : timeOffData.status === "Rejected"
                      ? "reject-top"
                      : timeOffData.status === "Cancelled"
                        ? "cancel-top"
                        : ""
                  }`}>
                  {timeOffData?.status || "Pending"}
                </div>
              )}
            </>
          )}
        </div>
        <div className="btn-aary">
          {isRefetching ? (
            <>
              {user &&
                ((user.userType === USER) ||
                  ([SUPER_ADMIN, ADMIN, TEAM_MANAGER].includes(
                    user.userType
                  ))) && (
                  <div
                    style={{
                      width: "100px",
                      height: "44px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "6px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      marginRight: "14px",
                    }}
                  />
                )}
              <div
                style={{
                  width: "92px",
                  height: "44px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "6px",
                  animation: "pulse 1.5s ease-in-out infinite",
                  marginRight: "14px",
                }}
              />
              {(user &&
                (user.userType === SUPER_ADMIN ||
                  user.userType === ADMIN ||
                  user.userType === TEAM_MANAGER)) && (
                  <div
                    style={{
                      width: "140px",
                      height: "44px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "6px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                )}
            </>
          ) : (
            <>
              {user &&
                ((user.userType === USER && timeOffData?.status === "Pending") ||
                  ([SUPER_ADMIN, ADMIN, TEAM_MANAGER].includes(
                    user.userType
                  ) &&
                    ["Pending", "Approved", "Rejected", "Cancelled"].includes(
                      timeOffData?.status
                    ))) && (
                  <Link className="editbtn-in-sle" onClick={handleEdit} >
                    <img alt="Edit" src={editImage} /> Edit
                  </Link>
                )}
              <Modal
                className="client-modal sprint-modal time-off-close"
                isOpen={isEditModalOpen}
                onRequestClose={!isSubmitLoading ? handleCloseEditModal : undefined}
                contentLabel="Confirm Delete"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    parent: document.querySelector(".admin-outer.time.tracker"),
                  },
                }}
              >
                <div className="modal timeoff-modal">
                  <div className="modal-close-invite outter-modal-main">
                    <a className="" onClick={handleCloseEditModal} disabled={isSubmitLoading}>
                      <img src={crssrImage} alt="Edit Icon" />{" "}
                    </a>
                  </div>
                  <div className="modal-client-head">
                    <h2 className="">Update Time Off Request</h2>
                  </div>
                  <div className="form-field-client-outer">
                    <form onSubmit={handleTimeOffEditSubmit}>
                      {(user.userType === 1 || user.userType === 2) &&
                        (<div className="form-field-client">
                          <label htmlFor="client" className="form-label">
                            User
                          </label>
                          <div ref={userSelectDropdownRef} className={`cursor ${userDropdownOpen ? 'open' : ''}`} >
                            <span
                              id="user-select"
                              onClick={handleToggleUserDropdown}
                              className={`custom-dropdown-user-new custom-dropdown-user ${userEditIsValid ? 'input-validation-error' : ''}`}
                              ref={userRef}
                            >
                              {userIdEdit ? (
                                activeUser?.find((user) => user._id === userIdEdit)?.first_name ? (
                                  <>
                                    {activeUser?.find((user) => user._id === userIdEdit)?.first_name}{' '}
                                    {activeUser?.find((user) => user._id === userIdEdit)?.middle_name &&
                                      activeUser?.find((user) => user._id === userIdEdit)?.middle_name !== 'null'
                                      ? activeUser?.find((user) => user._id === userIdEdit)?.middle_name + ' '
                                      : ''}
                                    {activeUser?.find((user) => user._id === userIdEdit)?.last_name}{' '}
                                  </>
                                ) : (
                                  <>
                                    {activeUser.find((user) => user._id === userIdEdit)?.company_first_name
                                      ? `${activeUser.find((user) => user._id === userIdEdit)?.company_first_name} ${activeUser.find((user) => user._id === userIdEdit)?.company_last_name
                                        ? activeUser.find((user) => user._id === userIdEdit)?.company_last_name
                                        : ''
                                      }`
                                      : `${activeUser.find((user) => user._id === userIdEdit)?.company_name || ''}(Company)`}
                                  </>
                                )
                              ) : (
                                'Select User'
                              )}
                            </span>
                            {userDropdownOpen && (
                              <div className="custom-dropdown-new">
                                <input
                                  type="text"
                                  className="search-bar"
                                  placeholder="Search..."
                                  value={userSearchTerm}
                                  onChange={handleUserSearchInputChange}
                                />
                                <ul className="client-list">
                                  {filteredUsers.length > 0 &&
                                    filteredUsers
                                      .slice()
                                      .sort((a, b) => {
                                        const nameA = a.first_name
                                          ? `${a.first_name} ${a.middle_name || ''} ${a.last_name}`
                                          : `${a.company_first_name ? a.company_first_name + (a.company_last_name && a.company_last_name) : a.company_name}`;
                                        const nameB = b.first_name
                                          ? `${b.first_name} ${b.middle_name || ''} ${b.last_name}`
                                          : `${b.company_first_name ? b.company_first_name + (b.company_last_name && b.company_last_name) : b.company_name}`;
                                        return nameA.localeCompare(nameB);
                                      })
                                      .map((item) => (
                                        <li key={item._id} className={userIdEdit === item._id ? 'selected-item' : ''} onClick={() => handleSelectUserEdit(item._id)}>
                                          {item.first_name ? (
                                            <>
                                              {item.first_name}{' '}
                                              {item.middle_name && item.middle_name !== 'null' ? item.middle_name + ' ' : ''}
                                              {item.last_name}{' '}
                                            </>
                                          ) : (
                                            <>
                                              {item.company_first_name
                                                ? `${item.company_first_name} ${item.company_last_name ? item.company_last_name : ''}`
                                                : `${item.company_name || ''}(Company)`}
                                            </>
                                          )}
                                        </li>
                                      ))
                                  }
                                </ul>
                              </div>
                            )}
                          </div>

                          {userEditIsValid && (
                            <span className="text-red-500 text-xs italic">
                              User needs to be selected
                            </span>
                          )}
                        </div>)}
                      <div className="form-field-client">
                        <label htmlFor="client" className="form-label">
                          Type of Leave
                        </label>
                        <div
                          ref={leaveTypeSelectDropdownRef}
                          className={`cursor ${leaveTypeDropdownOpen ? 'open' : ''}`}
                        >
                          <span
                            id="user-select"
                            onClick={() => setLeaveTypeDropdownOpen(!leaveTypeDropdownOpen)}
                            className={`custom-dropdown-user-new custom-dropdown-select`}
                            ref={leaveTypeEditRef}
                          >
                            {
                              typeOfLeaveEdit
                                ? Array.isArray(leaveType)
                                  ? leaveType.find((leave) => leave._id === typeOfLeaveEdit)?.leave_type
                                  : null
                                : 'Select'
                            }
                          </span>
                          {leaveTypeDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <ul className="leave-type-list">
                                {leaveType &&
                                  leaveType
                                    .slice()
                                    .sort((a, b) => a.leave_type?.toLowerCase().localeCompare(b.leave_type?.toLowerCase()))
                                    .map((leave) => (
                                      <li
                                        key={leave._id}
                                        className={typeOfLeaveEdit === leave._id ? 'selected-item' : ''}
                                        onClick={() => {
                                          setTypeOfLeaveEdit(leave._id);
                                          setLeaveTypeDropdownOpen(false);
                                        }}
                                      >
                                        {leave.leave_type}
                                      </li>
                                    ))}
                              </ul>
                            </div>
                          )}
                        </div>
                        {leaveTypeEditIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Leave Type field Cannot be empty
                          </span>
                        )}
                      </div>
                      <div className="form-field-client" >
                        <label htmlFor="projectName" className="form-label">
                          Time Off Dates
                        </label>
                        <div className="date-picker-outer date-picker-outer-all">
                          <div className="custom-picker-icon custom-picker-icon-all">
                            <svg
                              width="1em"
                              height="1em"
                              viewBox="0 0 14 14"
                              fill="currentColor"
                              aria-hidden="true"
                              focusable="false"
                              className="rs-picker-toggle-caret rs-icon"
                              aria-label="calendar"
                              data-category="legacy"
                            >
                              <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                            </svg>
                          </div>
                          <div className="custoom-icon-calender custoom-icon-calender-all">
                            <div ref={dateRangeRef}>
                              <DateRangePicker
                                showOneCalendar
                                format="dd/MM/yyyy"
                                placeholder="From - to"
                                placement="topEnd"
                                ranges={ranges}
                                className="project-calender time-off-cal"
                                value={dateRangeEdit}
                                onChange={handleSelectEdit}
                                isoWeek={appSettings.weekStartDay === 'Monday'}
                              />
                            </div>
                          </div>
                        </div>

                        {dateRangeEditIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Select the range of dates you want time off
                          </span>
                        )}
                      </div>
                      {dateRangeTypeEdit === "single" && (
                        <div className="form-field-client radio-sec">
                          <div className="form-field-client">
                            <label htmlFor="client" className="form-label">
                              Start Time
                            </label>

                            {/* <div
                          className={`custom-dropdown-user-new-outer custom-dropdown-select ${startTimeDropdownOpen ? 'open' : ''
                            }`}
                          ref={startTimeDropdownRef}
                        >
                          <div
                            className="selected-option custom-dropdown-user-new"
                            onClick={handleToggleStartTimeDropdown}
                            style={{ cursor: 'pointer' }}
                            ref={startTimeRef}
                          >
                            {startTimeEdit ? timeList.find((time) => time.time_value === startTimeEdit)?.time : 'Select'}
                          </div>
                          {startTimeDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <ul className="time-list">
                                {timeList.map((time) => (
                                  <li
                                    key={time.time_value}
                                    className={startTimeEdit === time.time_value ? 'selected-item' : ''}
                                    onClick={() => {
                                      setStartTimeEdit(time.time_value);
                                      setStartTimeDropdownOpen(false);
                                    }}
                                  >
                                    {time.time}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div> */}
                            <input
                              type="time"
                              id="start-time"
                              ref={startTimeRef}
                              value={startTimeEdit}
                              onChange={(e) => setStartTimeEdit(e.target.value)}
                              className="custom-time-input"
                            />
                            {startTimeEditIsValid && (
                              <span className="text-red-500 text-xs italic">
                                Please select a valid start time.
                              </span>
                            )}
                          </div>
                          <div className="form-field-client">
                            <label htmlFor="client" className="form-label">
                              End Time
                            </label>

                            {/* <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${endTimeDropdownOpen ? 'open' : ''}`} ref={endTimeDropdownRef}>
                          <div
                            className="selected-option custom-dropdown-user-new"
                            onClick={handleToggleEndTimeDropdown}
                            style={{ cursor: 'pointer' }}
                            ref={endTimeRef}
                          >
                            {endTimeEdit ? timeList.find((time) => time.time_value === endTimeEdit)?.time : 'Select'}
                          </div>
                          {endTimeDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <ul className="time-list">
                                {timeList.map((time) => (
                                  <li
                                    key={time.time_value}
                                    className={endTimeEdit === time.time_value ? 'selected-item' : ''}
                                    onClick={() => {
                                      setEndTimeEdit(time.time_value);
                                      setEndTimeDropdownOpen(false);
                                    }}
                                  >
                                    {time.time}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div> */}
                            <input
                              type="time"
                              id="end-time"
                              ref={endTimeRef}
                              value={endTimeEdit}
                              onChange={(e) => setEndTimeEdit(e.target.value)}
                              className="custom-time-input"
                            />
                            {endTimeEditIsValid && (
                              <span className="text-red-500 text-xs italic">
                                Please select a valid end time.
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="form-field-client">
                        <label htmlFor="description" className="form-label">
                          Upload Document
                        </label>
                        <input
                          type="file"
                          name="Upload Document"
                          className={
                            documentEditIsValid
                              ? "input-validation-error form-select"
                              : "form-input"
                          }
                          onChange={handleUploadDocEditChange}
                          ref={documentRef}
                        />
                        {uploadDocumentEditName &&
                          <div
                            onClick={() => downloadTimeOffDoc(uploadDocumentEditName)}
                            style={{ cursor: 'pointer' }}
                          >
                            {uploadDocumentEditName.length > 30 ? (
                              <span
                                className="shortened-name"
                                title={uploadDocumentEditName}
                              >
                                {uploadDocumentEditName.slice(0, 30)}...
                              </span>
                            ) : (
                              uploadDocumentEditName
                            )}
                          </div>
                        }
                        {documentEditIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Invalid file format
                          </span>
                        )}
                      </div>
                      <div className="form-field-client">
                        <label htmlFor="description" className="form-label">
                          Remarks
                        </label>
                        <textarea
                          id="Remark"
                          required
                          name="Remark"
                          className={
                            noteEditIsValid
                              ? "input-validation-error form-textarea"
                              : "form-textarea"
                          }
                          rows="3"
                          value={noteEdit}
                          onChange={(e) => setNoteEdit(e.target.value)}
                          ref={noteRef}
                        ></textarea>
                        {noteEditIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Remark Cannot be empty
                          </span>
                        )}
                      </div>
                      <button type="submit" disabled={isSubmitLoading} className="submit-client">
                        {isSubmitLoading ? (
                          <div
                            style={{
                              width: "120px",
                              height: "20px",
                              backgroundColor: "rgba(255, 255, 255, 0.3)",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                              margin: "0 auto",
                            }}
                          />
                        ) : (
                          "Update Request"
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </Modal>

              {isRefetching ? (
                <div
                  className="editbtn-in-slp"
                  style={{
                    backgroundColor: "#e5e7eb",
                    cursor: "default",
                    pointerEvents: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "60px",
                      height: "17px",
                      backgroundColor: "#cbd5e1",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                </div>
              ) : (
                timeOffData?._id ? (
                  <a className="editbtn-in-slp" onClick={handlePrint}>
                    {" "}
                    <img src={pImage} alt="printer Icon" /> Print
                  </a>
                ) : (
                  <div
                    className="editbtn-in-slp"
                    style={{
                      backgroundColor: "#e5e7eb",
                      cursor: "default",
                      pointerEvents: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "17px",
                        backgroundColor: "#cbd5e1",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </div>
                )
              )}

              {isRefetching && ((user &&
                (user.userType === SUPER_ADMIN ||
                  user.userType === ADMIN ||
                  user.userType === TEAM_MANAGER)) ||
                (timeOffData?.start_date &&
                  moment.tz(timeOffData.start_date, global.config.getTimeZone()).isAfter(
                    moment.tz(global.config.getTimeZone()),
                    "day"
                  ))) ? (
                <div
                  className="editbtn-in-sld"
                  style={{
                    backgroundColor: "#e5e7eb",
                    cursor: "default",
                    pointerEvents: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "120px",
                      height: "17px",
                      backgroundColor: "#cbd5e1",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                </div>
              ) : (
                ((user &&
                  (user.userType === SUPER_ADMIN ||
                    user.userType === ADMIN ||
                    user.userType === TEAM_MANAGER)) ||
                  (timeOffData?.start_date &&
                    moment.tz(timeOffData.start_date, global.config.getTimeZone()).isAfter(
                      moment.tz(global.config.getTimeZone()),
                      "day"
                    ))) && (
                  <>
                    {timeOffData?._id ? (
                      <a
                        className="editbtn-in-sld"
                        onClick={handleDelete}
                        disabled={isSubmitLoading}
                      >
                        <img src={deleteImage} alt="Delete" /> Delete Request
                      </a>
                    ) : (
                      <div
                        className="editbtn-in-sld"
                        style={{
                          backgroundColor: "#e5e7eb",
                          cursor: "default",
                          pointerEvents: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "120px",
                            height: "17px",
                            backgroundColor: "#cbd5e1",
                            borderRadius: "4px",
                            animation: "pulse 1.5s ease-in-out infinite",
                          }}
                        />
                      </div>
                    )}
                  </>
                )
              )}
              <Modal
                className="delete-modal"
                isOpen={isDeleteModalOpen}
                onRequestClose={
                  !isSubmitLoading ? handleCancelDelete : undefined
                }
                contentLabel="Confirm Delete"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    parent: document.querySelector(
                      ".admin-outer.time.tracker"
                    ),
                  },
                }}
              >
                <div className="delete-modal-content">
                  <h2>Confirm Delete</h2>
                  <p>
                    Are you sure you want to delete this Time Off
                    Request?
                  </p>
                  {isSubmitLoading ? (
                    <div className="delete-modal-buttons">
                      <div
                        style={{
                          width: "80px",
                          height: "40px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "6px",
                          animation: "pulse 1.5s ease-in-out infinite",
                          marginRight: "10px",
                        }}
                      />
                      <div
                        style={{
                          width: "80px",
                          height: "40px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "6px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                  ) : (
                    <div className="delete-modal-buttons">
                      <button
                        className="buttons-rejected"
                        onClick={handleConfirmDelete}
                        disabled={isSubmitLoading}
                      >
                        Delete
                      </button>
                      <button
                        onClick={handleCancelDelete}
                        disabled={isSubmitLoading}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              </Modal>
            </>
          )}
        </div>

      </div>
      <div className="comment-container-outer">
        {/* Your invoice layout */}
        {/* <CommnetContainer from={window.location.pathname + window.location.search + window.location.hash} /> */}
        <Suspense fallback={<div></div>}>
          <CommnetContainer
            from={window.location.pathname + window.location.search + window.location.hash}
            addUsers={[{
              _id: timeOffData?.user?._id,
              name: (() => {
                const user = timeOffData?.user;
                if (!user) return '';
                return user.user_category !== 2
                  ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
                  : `${user.company_first_name || ''} ${user.company_last_name || ''}`.trim();
              })(),
              email: timeOffData?.user?.email || ''
            }]}
            permissions={["Admin", "Super Admin", "Project Manager"]}
          />
        </Suspense>
      </div>
      {/* Pulse animation style */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default TimeOffActions;